import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { PartesService } from '../../services/partes.services';

/**
 * Generated class for the PersonalDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-personal-detalle',
  templateUrl: 'personal-detalle.html',
})
export class PersonalDetallePage {

  item = {id : null, Nombre : null, cuadrilla : false,Activo : false};
  cuadrillas = [{id:null,Nombre : null,idEmpresa : null}];
  
  constructor(public navCtrl: NavController, public navParams: NavParams,public alertCtrl: AlertController,public partesService : PartesService) {
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }

    //Cargo las Cuadrillas
    partesService.getCuadrillas()
    .subscribe(cuadrillas => {
      this.cuadrillas = cuadrillas;
  });
  }

  //Añadir Persona
  addPersona(){
    this.partesService.addPersona(this.item);
    this.navCtrl.pop();
  } 

  //Borrar Persona
  deletePersona(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar esta Persona?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deletePersona(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  } 
  ionViewDidLoad() {
    console.log('ionViewDidLoad PersonalDetallePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/personal-detalle/personal-detalle.ts